import React from "react";
import { withRouter } from 'react-router';
import util from "../../../util/tools";
let outterStyle = {
    textAlign:"center",
    padding:"0.1rem 0rem 0rem",
    borderTop:"0.06rem solid #EDEDED",
    marginTop:"0.1rem"
}
let itemStyle = {
    color:"#999999",
    fontSize:"0.24rem",
    lineHeight:"0.3rem",
}

let jumpUrl = "http://beian.miit.gov.cn"

@withRouter
export default class IndexBottom extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            data:{
                "copyright": "",//版权
                "phone": "",//电话
                "record": "",//备案
                "zzdxpermit": "",//增值电信业务经营许可证
                "wlwhpermit": "",//网络文化经营许可证
                "wlcbpermit": ""//网络出版服务许可证
            }
        }
    }

    componentDidMount() {
        let params = {
            url: "/zh/additional/webinfo",
            data: {
                domain:document.domain
            }
        };
        util.ajax({
            url: params.url,
            isUser: true,
            isWechatId: true,
            data: params.data,
            callback: res => {
                if (res.result.status.code == 0) {
                    let json = res.result.data;
                    // console.log(json)
                    this.setState({
                        data:json
                    })
                }
            }
        });
    }

    render(){
        let {copyright,phone,record,zzdxpermit,wlwhpermit,wlcbpermit} = this.state.data
        return (
            <div style={outterStyle}>
                <div style={itemStyle}>{copyright}</div>
                <div style={itemStyle}>{phone}</div>
                <div style={itemStyle}><a href={jumpUrl}>{record}</a></div>
                <div style={itemStyle}>{zzdxpermit}</div>
                <div style={itemStyle}>{wlwhpermit}</div>
                <div style={itemStyle}>{wlcbpermit}</div>

            </div>
        )
    }
}